import './XpektorBootstrapModal.scss';
import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import {
  XpektorForm,
  FormInput,
  FormButton,
} from '../../../Components/XpektorForms/XpektorForms';
import Regex from '../../../Components/Utilities/Regex';

const gT = (t, key) => t(`modal.add-support-info${key}`);
const gsT = (t, key) => t(`shared${key}`);

/* eslint-disable react/prop-types */
export default function AddSupportInfoModal({
  handleClose,
  onSubmit,
  customer,
  t,
}) {
  const [supportEmail, setSupportEmail] = useState('');
  const [supportPhone, setSupportPhone] = useState('');

  const [emailError, setEmailError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(customer).length !== 0) {
      setSupportEmail(customer.supportEmail);
      setSupportPhone(customer.supportPhoneNumber);
    }
  }, [customer]);

  const validateAndSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);

    let emailValid = true;
    let phoneValid = true;
    let newEmailError = '';
    let newPhoneError = '';

    if (supportEmail.length === 0) {
      newEmailError = gsT(t, '.errors.empty-field');
      emailValid = false;
    } else if (!Regex.testEmail(supportEmail)) {
      newEmailError = gsT(t, '.errors.invalid-email');
      emailValid = false;
    }

    if (supportPhone.length === 0) {
      newPhoneError = gsT(t, '.errors.empty-field');
      phoneValid = false;
    }

    setEmailError(newEmailError);
    setPhoneError(newPhoneError);

    if (!phoneValid || !emailValid) {
      setSubmitting(false);
      return;
    }

    const supportInfo = { email: supportEmail, phone: supportPhone };

    onSubmit(supportInfo);
  };

  return (
    <Modal
      show
      onHide={handleClose}
      backdrop="static"
      centered
      keyboard={false}
      className="border-0 xpektor-bootstrap-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{gT(t, '.modal-title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {gT(t, '.body-text.0')}
          <br />
          <br />
          {gT(t, '.body-text.1')}
          &quot;
          {gT(t, '.body-text.2')}
          &quot;.
        </p>
        <XpektorForm onSubmit={validateAndSubmit}>
          <FormInput
            label={gT(t, '.form-input-label.support-email')}
            type="text"
            value={supportEmail}
            onChange={(e) => setSupportEmail(e.target.value)}
            infoText={emailError}
          />
          <FormInput
            label={gT(t, '.form-input-label.support-phone-nr')}
            regex={Regex.testPhoneNrInput}
            value={supportPhone}
            onChange={(e) => setSupportPhone(e.target.value)}
            infoText={phoneError}
          />
          <FormButton text={gT(t, '.form-btn.text')} disabled={submitting} />
        </XpektorForm>
      </Modal.Body>
    </Modal>
  );
}
